import * as yup from 'yup';

yup.addMethod(yup.string, 'confirmPassword', function () {
  return this.test('confirmPassword', function () {
    const { path, createError } = this;
    const fieldConfirmPassword = document.getElementsByName(path)[0];
    const fieldPassword = document.getElementsByName('password')[0];
    return new Promise((resolve, reject) => {
      if (
        fieldConfirmPassword &&
        fieldPassword &&
        fieldConfirmPassword.value === fieldPassword.value
      ) {
        resolve(true);
      } else {
        reject(
          createError({
            path,
            message: 'passwords not match ',
            type: 'confirmPassword'
          })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'select', function (nameField) {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(nameField)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  email: yup
    .string()
    .required()
    .email()
    .trim(),
  username: yup
    .string()
    .min(3)
    .max(30)
    .required()
    .trim(),
  password: yup.string().when({
    is: '',
    then: yup
      .string()
      .test(
        'required',
        () => document.getElementsByName('password')[0].disabled
      ),
    otherwise: yup
      .string()
      .min(8)
      .max(50)
      .required()
      .trim()
  }),
  confirmPassword: yup.string().when({
    is: '',
    then: yup
      .string()
      .test(
        'required',
        () => document.getElementsByName('confirmPassword')[0].disabled
      ),
    otherwise: yup
      .string()
      .min(8)
      .max(50)
      .required()
      .trim()
      .confirmPassword()
  }),
  nameExtension: yup
    .string()
    .required()
    .trim(),
  department: yup
    .string()
    .required()
    .trim(),
  type: yup
    .string()
    .required()
    .trim(),
  company: yup.string().select('company'),
  permissionsGroup: yup.string().select('permissionsGroup')
});

export default schema;
